import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  Slide,
  TextField,
  ThemeProvider,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';
import {
  closeConfirmPasswordModal,
  getMessage,
  merchantStatusChange,
} from '../../../redux/creates-action/ConfirmPasswordAction';
import { useState } from 'react';
import { updateStatus } from '../../../services/Merchant';
import { useEffect } from 'react';
import { updateStatusEmployee } from '../../../services/Employee';
import { updateStatusSubMerchant } from '../../../services/SubMerchant';
import theme from '../../layout/theme/Theme';
import { updateStatusCategory } from '../../../services/Category';
import { redirectFromModalAction } from '../../../redux/creates-action/RedirectFromModalAction';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function ConfirmPasswordModal(props) {
  const [record, setRecord] = useState(null);
  const data = useSelector((state) => state.password.data);
  const [status, setStatus] = useState(0);
  const dispatch = useDispatch();
  const [password, setPassword] = React.useState('');

  useEffect(() => {
    setRecord(data.record);
  }, [data.record]);
  useEffect(() => {
    if (record !== null) {
      setStatus(record.status);
    }
  }, [record]);

  const handleClose = () => {
    dispatch(closeConfirmPasswordModal());
  };

  const handleChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirm = (e) => {
    e.preventDefault();
    let feature = data.feature;
    switch (feature) {
      case 'CHANGE_PASSWORD':
        dispatch(closeConfirmPasswordModal());
        setPassword('');
        break;

      default:
        break;
      case 'CLOSE_MERCHANT':
        const data = {
          status: status === 1 ? 3 : status === 3 ? 2 : null,
          updateStatusMerchantId: record.id,
        };
        updateStatus(data, password)
          .then((result) => {
            if (result !== null) {
              dispatch(closeConfirmPasswordModal());
              dispatch(merchantStatusChange(result.status));
              setStatus(result.status);
              setPassword('');
              dispatch(
                getMessage(
                  result.status === 3
                    ? 'Merchant closed'
                    : result.status === 2
                      ? 'Request success'
                      : null,
                  'success'
                )
              );
            }
          })
          .catch((errors) => {
            let err = JSON.parse(JSON.stringify(errors, undefined, 2));
            if (err.response !== undefined) {
              dispatch(getMessage(err.response.errors[0].message, 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            } else {
              dispatch(getMessage('Server error, please try again', 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            }
          });
        break;
      case 'CLOSE_EMPLOYEE':
        const employee = {
          status: status === 1 ? 3 : 1,
          updateStatusEmployeeId: record.id,
        };
        updateStatusEmployee(employee, password)
          .then((result) => {
            if (result !== null) {
              dispatch(closeConfirmPasswordModal());
              dispatch(merchantStatusChange(result.status));
              setStatus(result.status);
              setPassword('');
              dispatch(
                getMessage(
                  result.status === 3 ? 'Employee closed' : 'Employee opend',
                  'success'
                )
              );
            }
          })
          .catch((errors) => {
            let err = JSON.parse(JSON.stringify(errors, undefined, 2));
            if (err.response !== undefined) {
              dispatch(getMessage(err.response.errors[0].message, 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            } else {
              dispatch(getMessage('Server error, please try again', 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            }
          });
        break;
        case 'CLOSE_EMPLOYEE_SELF':
        const employeeSelf = {
          status: status === 1 ? 3 : 1,
          updateStatusEmployeeId: record.id,
        };
        updateStatusEmployee(employeeSelf, password)
          .then((result) => {
            if (result !== null) {
              dispatch(closeConfirmPasswordModal());
              dispatch(merchantStatusChange(result.status));
              setStatus(result.status);
              setPassword('');
              dispatch(
                getMessage(
                  result.status === 3 ? 'Employee closed' : 'Employee opend',
                  'success'
                )
              );
              localStorage.clear();
              window.location = '/login'
            }
          })
          .catch((errors) => {
            let err = JSON.parse(JSON.stringify(errors, undefined, 2));
            if (err.response !== undefined) {
              dispatch(getMessage(err.response.errors[0].message, 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            } else {
              dispatch(getMessage('Server error, please try again', 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            }
          });
        break;
      case 'CLOSE_SUBMERCHANT':
        const subMerchant = {
          status: status === 1 ? 3 : 1,
          updateStatusSubMerchantId: record.id,
        };
        updateStatusSubMerchant(subMerchant, password)
          .then((result) => {
            if (result !== null) {
              dispatch(closeConfirmPasswordModal());
              dispatch(merchantStatusChange(result.status));
              setStatus(result.status);
              setPassword('');
              dispatch(
                getMessage(
                  result.status === 3
                    ? 'SubMerchant closed'
                    : result.status === 1
                      ? 'SubMerchant Opend'
                      : null,
                  'success'
                )
              );
            }
          })
          .catch((errors) => {
            let err = JSON.parse(JSON.stringify(errors, undefined, 2));
            if (err.response !== undefined) {
              dispatch(getMessage(err.response.errors[0].message, 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            } else {
              dispatch(getMessage('Server error, please try again', 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            }
          });
        break;
      case 'DELETE_CATEGORY':
        const category = {
          status: 3,
          updateStatusCategoryId: record.id,
        };
        updateStatusCategory(category, password)
          .then((result) => {
            if (result !== null) {
              dispatch(closeConfirmPasswordModal());
              dispatch(redirectFromModalAction());
              setPassword('');
              dispatch(getMessage('Delete category successfully'));
            }
          })
          .catch((errors) => {
            let err = JSON.parse(JSON.stringify(errors, undefined, 2));
            if (err.response !== undefined) {
              dispatch(getMessage(err.response.errors[0].message, 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            } else {
              dispatch(getMessage('Server error, please try again', 'error'));
              dispatch(closeConfirmPasswordModal());
              setPassword('');
            }
          });
        break;
    }
  };
  return (
    <ThemeProvider theme={theme}>
      <Dialog
        onClose={handleClose}
        TransitionComponent={Transition}
        keepMounted
        open={data.isOpen}
      >
        <DialogTitle align="center" variant="h5" fontWeight="bold">
          {data.title}
        </DialogTitle>
        <Box pl="3rem" pr="3rem">
          <FormControl
            component="form"
            onSubmit={handleConfirm}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Typography variant="body1" align="center" sx={{ mb: 1 }}>
              {data.message}
            </Typography>
            <TextField
              variant="outlined"
              placeholder="Password"
              fullWidth
              type="password"
              required
              size="small"
              value={password || ''}
              onChange={handleChange}
            />
            <br />
          </FormControl>
        </Box>
        <DialogActions>
          <Button variant="contained" color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            autoFocus
            color="error"
            variant="contained"
            type="submit"
            onClick={handleConfirm}
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
